import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { addCustomerUser } from '../../services/customer';
import { FormTextBox } from '../components/FormTextBox';

/**UI component for adding users to a company */
export default class UserForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            submit: false
        };
    }
    componentDidMount() {
        // getPublishedTrees();
    }
    /**When mounting will set up the labels for reusability */
    componentWillMount() {
        if (this.props.type === "tenantUsers") {
            this.setState({ label: "Users Email" });
        } else if (this.props.type === "demoUsers") {
            this.setState({ label: "Demo Users Email" });
        } else if (this.props.type === "controller") {
            this.setState({
                label: "Users Email",
                submit: true
            });
        }
        if (this.props.userData) {
            this.setState({ email: this.props.userData });
        }
    }
    /**This handles removing from any container state outside of component */
    componentWillUnmount() {
        // removeOnUnmount
        if (this.props.removeOnUnmount) {
            this.props.removeOnUnmount(this.props.id);
        }
    }
    /**On change handler, handles for container state if there */
    onChange = (ev, input) => {
        this.setState({ email: ev.target.value }, () => {
            if (this.props.addUser) {
                this.props.addUser(this.state.email, this.props.id, this.props.type);
            }
        });

    };
    /**Submit handler is used when its as a standalone component */
    onSubmit = () => {
        addCustomerUser(this.state.email, this.props.companyId);
        if (this.props.close) {
            this.props.close();
        }
    };
    render() {
        const { email, submit } = this.state;
        return (
            <div>
                <Form>
                    {/* <Form.Row> */}
                    <FormTextBox formLabel={this.state.label} textChanger={this.onChange}
                        name="email" value={email} placeholder="Email Address" readOnly={false} />
                    {submit ? <div>
                        <br /> <Button onClick={this.onSubmit} variant="success">Add Customer User</Button>
                    </div> : undefined}
                    {/* </Form.Row> */}
                </Form>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/adminCenter/UserForm.js